<script setup lang="ts">
import {Dialog, DialogContent, DialogTrigger} from "@/core/components/ui/dialog";
import BaseVideo from "@/core/components/base/BaseVideo.vue";
</script>

<template>
  <Dialog>
    <DialogTrigger>
      <slot />
    </DialogTrigger>
    <DialogContent class="w-full max-w-3xl">
      <BaseVideo reference="A3MCtVC67Lw" />
    </DialogContent>
  </Dialog>
</template>
